import React, { useState, useRef } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import AssetPreview from '../shared/asset-preview';
import AssetLibrary from '../shared/asset-library';
import './inspector.css';

export default function Inspector() {
  const [scene, setScene] = useState();
  const [activeChild, setActiveChild] = useState();
  const fileInputRef = useRef(null);

  const onSelectFile = (e) => {
    const file = e.target.files[0];
    const fileName = `assets/${file.name}`;
    const fileExt = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    if (fileExt !== 'glb') {
      alert('Invalid file type.');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const url = reader.result;
      onLoadGLB(url);
    };
  };

  const onLoadGLB = (url) => {
    const loader = new GLTFLoader();
    loader.load(url, (gltf) => {
      console.log(gltf);
      gltf.scene.children.sort((a, b) => a.name.localeCompare(b.name));
      setScene(gltf.scene);
    });
  };

  return (
    <div className="inspector__wrapper">
      <div className="inspector__header">
        <button
          className="inspector__upload"
          onClick={() => {
            fileInputRef.current.value = null;
            fileInputRef.current.click();
          }}
        >
          Upload GLB File
        </button>
        <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={onSelectFile} />
      </div>
      <div className="inspector">
        {scene && (
          <div className="inspector__scene">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Import</th>
                  <th>Type</th>
                  <th>Size</th>
                  <th>Cells</th>
                  <th>Materials</th>
                </tr>
              </thead>
              <tbody>
                {scene.children.map((child) => {
                  const box = new THREE.Box3();
                  const size = new THREE.Vector3();
                  let cells = '';
                  box.expandByObject(child);
                  box.getSize(size);
                  const width = Math.round(size.x / 5);
                  const height = Math.round(size.z / 5);
                  cells = `${width} ⨉ ${height}`;

                  return (
                    <tr key={child.uuid} className="inspector__item">
                      <td className="gltf__name">
                        <button className="inspector__link" onClick={() => setActiveChild(child)}>
                          {child.name}
                        </button>
                      </td>
                      <td className="gltf__import">{AssetLibrary.willBeImported(child.name) ? '✓' : ''}</td>
                      <td className="gltf__type">{child.type}</td>
                      <td className="gltf__size">
                        [{size.x.toFixed(1)}&nbsp;{size.y.toFixed(1)}&nbsp;{size.z.toFixed(1)}]
                      </td>
                      <td className="gltf__size">{cells}</td>
                      <td className="gltf__material">{child.type === 'Group' && child.children.length}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <AssetPreview object={activeChild} />
          </div>
        )}
      </div>
    </div>
  );
}
